// extracted by mini-css-extract-plugin
module.exports = {"main":"CreatePlayers_main__1VluF"};